import { Card, CardActions, CardContent, CardHeader, cardHeaderClasses, CardProps, Typography } from "@mui/material";
import { ReactNode, useMemo } from "react";

export type EdmCardPropsType = CardProps & {
  headerAction?: ReactNode;
  actions?: ReactNode;
  subtitle?: ReactNode;
  halfWidth?: boolean;
};

const cardContentSx = {
  padding: 3,
  "& .MuiToolbar-root": {
    paddingLeft: 0,
    paddingRight: 0,
  },
};

export default function EdmCard(props: EdmCardPropsType) {
  const {
    children,
    headerAction = undefined,
    actions = undefined,
    title = undefined,
    subtitle = undefined,
    sx = {},
    halfWidth = false,
    ...cardProps
  } = props;

  const halfWidthSx = useMemo(() => {
    return halfWidth
      ? {
          width: "50%",
          minWidth: "486px",
        }
      : {};
  }, [halfWidth]);

  const cardTitle = useMemo(() => {
    return title ? (
      <Typography variant="h6" component="h2">
        {title}
      </Typography>
    ) : null;
  }, [title]);

  return (
    <Card
      sx={{
        width: "100%",
        ...sx,
        ...halfWidthSx,
      }}
      {...cardProps}
    >
      {cardTitle && (
        <CardHeader
          classes={cardHeaderClasses}
          title={cardTitle}
          subheader={subtitle}
          subheaderTypographyProps={{
            color: "textSecondary",
            variant: "subtitle2",
          }}
          action={headerAction}
        />
      )}
      <CardContent sx={cardContentSx}>{children}</CardContent>
      {actions && <CardActions>{actions}</CardActions>}
    </Card>
  );
}
